
/*eslint-disable*/
import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

// reactstrap components
import { Container, Row, Nav, NavItem, NavLink } from "reactstrap";

class Footer extends React.Component {
  render() {
    return (
      <footer className="footer">
        <Container fluid>
          <Nav>
            <NavItem>
              <NavLink href="https://www.agrotecsa.com.mx">AgroTECSA</NavLink>
            </NavItem>
          </Nav>
          <div className="copyright">
            © {new Date().getFullYear()} by{" "}
            <a
              href="https://www.agrotecsa.com.mx"
              target="_blank"
            >
              AgorTECSA
            </a>{" "}
            PumpMonitor.
          </div>
        </Container>
      </footer>
    );
  }
}

export default Footer;
